// extracted by mini-css-extract-plugin
module.exports = {"container":"item-content-toolbar_container__3Vp_z","main-container":"item-content-toolbar_main-container__3aW5V","detail-container":"item-content-toolbar_detail-container__LLwVT"};